import React from 'react';
import {I18n} from 'react-redux-i18n';
import {withStyles, WithStyles} from '@material-ui/core';

import loadingImg from './img/loading.gif';

import style from './style';

type SpinnerProps = WithStyles<typeof style> & {
  className?: string;
};

function Spinner({
  classes,
  className = '',
}: SpinnerProps) {
  return (
    <img
      src={loadingImg}
      alt={I18n.t('loading.altText')}
      className={`${classes.spinner} ${className}`}
    />
  );
}

export default withStyles(style)(Spinner);
